import { getToken, getUserInfo, getPermissions } from '@/api/auth'
import { onVolcAssetsChanged } from '@/utils/volcAssetEvents'
import { createAssetLibraryCache } from '../../volc-asset/assetLibraryCache'

export const mentionAccountScope = () => JSON.stringify([getUserInfo()?.userId, [...(getPermissions() || [])].sort()])
export const mentionAssetsCache = createAssetLibraryCache({
  // Memory only: credentials and reference URLs are not serialized to local storage.
  storage: () => null, scope: mentionAccountScope, session: getToken,
  ttl: 180000, retention: 180000, maxEntries: 30
})
// Keep invalidation alive when the video route is unmounted.
onVolcAssetsChanged(() => mentionAssetsCache.invalidate())
